/**
 * @description 分镜页面 store
 */

import {create} from 'zustand';
import type {MediaTypeValue} from '@/types/media';

/** 媒体预览弹窗的来源：参考素材（refImage/refVideo）或 分镜素材（imageMaterials/videoMaterials/audio） */
export type MediaSource = 'ref' | 'storyboard';

interface EpisodeState {
    /** 是否为竖版比例（3:4、9:16） */
    vertical: boolean;
    setVertical: (v: boolean) => void;
    /** 分镜素材预览弹窗 */
    storyboardMediaModalOpen: boolean;
    activeMediaStoryboardId: number | undefined;
    mediaSource: MediaSource;
    activeMediaTab: MediaTypeValue | undefined;
    openStoryboardMediaModal: (
        storyboardId: number,
        source: MediaSource,
        activeTab?: MediaTypeValue,
    ) => void;
    closeStoryboardMediaModal: () => void;

    /**
     * 列展示设置：`${projectId}-${episodeId}` → (列 key → 是否可见)
     * 由 useColumnSettings 读写，EpisodePage / EpisodeHeader 共享同一份状态。
     * 按 project+episode 分 key 存储，切换分集后各自独立。
     */
    visibleColumnMaps: Record<string, Record<string, boolean>>;
    setVisibleColumnMap: (scopeKey: string, map: Record<string, boolean>) => void;
}

export const useEpisodeStore = create<EpisodeState>((set) => ({
    vertical: false,
    setVertical: (v) => set({vertical: v}),
    storyboardMediaModalOpen: false,
    activeMediaStoryboardId: undefined,
    mediaSource: 'ref',
    activeMediaTab: undefined,
    openStoryboardMediaModal: (storyboardId, source, activeTab) =>
        set({
            storyboardMediaModalOpen: true,
            activeMediaStoryboardId: storyboardId,
            mediaSource: source,
            activeMediaTab: activeTab,
        }),
    closeStoryboardMediaModal: () =>
        set({
            storyboardMediaModalOpen: false,
            activeMediaTab: undefined,
        }),
    visibleColumnMaps: {},
    setVisibleColumnMap: (scopeKey, map) =>
        set((state) => ({
            visibleColumnMaps: {...state.visibleColumnMaps, [scopeKey]: map},
        })),
}));
